import AuthService from "./AuthService";

export default class UserService {
  public static hasWritePermission(): Boolean {
    const user = AuthService.getUser();
    if (!user) return false;

    return user.authorities.some((v) => v === "WRITE_PERMISSION");
  }

  public static hasReadPermission(): Boolean {
    const user = AuthService.getUser();
    if (!user) return false;

    return user.authorities.some((v) => v === "READ_PERMISSION");
  }
}
